module.exports = __webpack_public_path__ + "static/media/saved-projects.e694191f.jpeg";